import { render, staticRenderFns } from "./WordCount.vue?vue&type=template&id=6dc4c50a"
import script from "./WordCount.vue?vue&type=script&lang=js"
export * from "./WordCount.vue?vue&type=script&lang=js"
import style0 from "./WordCount.vue?vue&type=style&index=0&id=6dc4c50a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports